export default __webpack_public_path__ + "static/media/paystation_logo.80c05c90.svg";